const language = {
    "登录": {
        "zh": "登录",
        "en":"Login"
    },
    "服务税": {
      "zh": "服务税",
      "en":"Service tax"
    },
    "商品库存":{
      "zh":"商品库存",
      "en":"Merchandise inventory"
    },
    "库存":{
      "zh":"库存",
      "en":"Inventory"
    },
    "价格":{
      "zh":"价格",
      "en":"Price"
    },
  "政府税": {
    "zh": "政府税",
    "en":"Government tax"
    },
    "会员详情": {
        "zh": "会员详情",
        "en":"Member Details"
    },
    "会员手机号": {
        "zh": "会员手机号",
        "en":"Member's phone number"
    },
    "抵扣金额": {
        "zh": "抵扣金额",
        "en":"Deduction amount"
    },
    "还需支付金额": {
        "zh": "还需支付金额",
        "en":"Amount to be paid"
    },
    "组合付方式": {
        "zh": "组合付方式",
        "en":"Combination payment method"
    },
    "请输入会员手机号": {
        "zh": "请输入会员手机号",
        "en":"Please enter the member's phone number"
    },
    "请输入会员姓名": {
        "zh": "请输入会员姓名",
        "en":"Please enter the member's name"
    },
    "请输入充值金额": {
        "zh": "请输入充值金额",
        "en":"Please enter the recharge amount"
    },
    "会员充值": {
        "zh": "会员充值",
        "en":"Member recharge"
    },
    "新增会员": {
        "zh": "新增会员",
        "en":"New Members"
    },
    "现有余额": {
        "zh": "现有余额",
        "en":"Existing balance"
    },
    "请输入手机号/账号": {
        "zh": "请输入手机号/账号",
        "en":"Please enter your phone number/account"
    },
    "请输入密码": {
        "zh": "请输入密码",
        "en":"Please enter the password"
    },
    "账号不能为空": {
        "zh": "账号不能为空",
        "en":"Account cannot be empty"
    },
    "账号格式不正确": {
        "zh": "账号格式不正确",
        "en":"Login"
    },
    "密码不能为空": {
        "zh": "密码不能为空",
        "en":"Password cannot be empty"
    },
    "密码格式不正确": {
        "zh": "密码格式不正确",
        "en":"Incorrect password format"
    },
    "登录成功": {
        "zh": "登录成功",
        "en":"Login succeeded"
    },
    "桌台设置": {
        "zh": "桌台设置",
        "en":"Table Settings"
    },
    "确定要结束营业吗?": {
        "zh": "确定要结束营业吗?",
        "en":"Are you sure you want to close the business?"
    },
    "取消": {
        "zh": "取消",
        "en":"Cancel"
    },
    "确定": {
        "zh": "确定",
        "en":"determine"
    },
    "可用": {
        "zh": "可用",
        "en":"available"
    },
    "不可用": {
        "zh": "不可用",
        "en":"Not Available"
    },
    "人数": {
        "zh": "人数",
        "en":"Number of People"
    },
    "人": {
        "zh": "人",
        "en":""
    },
    "桌号": {
        "zh": "桌号",
        "en":"Table Number"
    },
    "号": {
        "zh": "号",
        "en":""
    },
    "合计(元)": {
        "zh": "合计(元)",
        "en":"Total (RM)"
    },
    "订单详情": {
        "zh": "订单详情",
        "en":"Order Details"
    },
    "结账": {
        "zh": "结账",
        "en":"CheckOut"
    },
    "加菜": {
        "zh": "加菜",
        "en":"add a dish"
    },
    "打印小票": {
        "zh": "打印小票",
        "en":"Print Small Ticket"
    },
    "点餐信息": {
        "zh": "点餐信息",
        "en":"Ordering Information"
    },
    "加单": {
        "zh": "加单",
        "en":"Add order"
    },
    "点餐时间": {
        "zh": "点餐时间",
        "en":"Order time"
    },
    "金额": {
        "zh": "金额",
        "en":"amount of money"
    },
    "操作": {
        "zh": "操作",
        "en":"operate"
    },
    "商品": {
        "zh": "商品",
        "en":"commodity"
    },
    "数量": {
        "zh": "数量",
        "en":"quantity"
    },
    "单价": {
        "zh": "单价",
        "en":"unit price"
    },
    "小计": {
        "zh": "小计",
        "en":"subtotal"
    },
    "删除": {
        "zh": "删除",
        "en":"Delete"
    },
    "结账详情": {
        "zh": "结账详情",
        "en":"Checkout details"
    },
    "现金支付": {
        "zh": "现金支付",
        "en":"Cash payment"
    },
    "POS支付": {
        "zh": "POS支付",
        "en":"POS payment"
    },
    "POS机支付": {
        "zh": "POS机支付",
        "en":"POS payment"
    },
    "扫码支付": {
        "zh": "扫码支付",
        "en":"Scan code payment"
    },
    "会员卡结账": {
        "zh": "会员卡结账",
        "en":"Membership card checkout"
    },
    "优惠金额": {
        "zh": "优惠金额",
        "en":"Discount amount"
    },
    "件商品": {
        "zh": "件商品",
        "en":"items in total"
    },
    "共": {
        "zh": "共",
        "en":""
    },
    "合计：": {
        "zh": "合计：",
        "en":"Total:"
    },
    "立即加菜": {
        "zh": "立即加菜",
        "en":"add a dish"
    },
    "加菜成功": {
        "zh": "加菜成功",
        "en":"Successfully added dishes"
    },
    "设置成功": {
        "zh": "设置成功",
        "en":"Successfully set"
    },
    "餐位费": {
        "zh": "餐位费",
        "en":"Meal space fee"
    },
    "修改成功": {
        "zh": "修改成功",
        "en":"Successfully modified"
    },
    "删除成功": {
        "zh": "删除成功",
        "en":"Successfully deleted"
    },
    "空闲": {
        "zh": "空闲",
        "en":"idle"
    },
    "不可用": {
        "zh": "不可用",
        "en":"Not Available"
    },
    "打印成功": {
        "zh": "打印成功",
        "en":"Printing successful"
    },
    "优惠金额不能大于订单价格": {
        "zh": "优惠金额不能大于订单价格",
        "en":"The discount amount cannot be greater than the order price"
    },
    "结账成功": {
        "zh": "结账成功",
        "en":"Successfully settled the account"
    },
    "菜品": {
        "zh": "菜品",
        "en":"variety of dishes"
    },
    "请输入内容": {
        "zh": "请输入内容",
        "en":"Please enter content"
    },
    "菜品类型": {
        "zh": "菜品类型",
        "en":"Dish Type"
    },
    "请选择": {
        "zh": "请选择",
        "en":"Please select"
    },
    "重置": {
        "zh": "重置",
        "en":"resetting"
    },
    "筛选": {
        "zh": "筛选",
        "en":"screen"
    },
    "菜品类型": {
        "zh": "菜品类型",
        "en":"Dish Type"
    },
    "菜品名称": {
        "zh": "菜品名称",
        "en":"Dish Name"
    },
    "售罄": {
        "zh": "售罄",
        "en":"be sold out"
    },
    "上架": {
        "zh": "上架",
        "en":"grounding"
    },
    "选择时间": {
        "zh": "选择时间",
        "en":"Timing"
    },
    "开始日期": {
        "zh": "开始日期",
        "en":"Start date"
    },
    "结束日期": {
        "zh": "结束日期",
        "en":"End date"
    },
    "订单编号": {
        "zh": "订单编号",
        "en":"Order Number"
    },
    "桌台号": {
        "zh": "桌台号",
        "en":"Table Number"
    },
    "就餐人数": {
        "zh": "就餐人数",
        "en":"Number of Diners"
    },
    "实际支付金额(元)": {
        "zh": "加单实际支付金额(元)",
        "en":"Actual payment amount (RM)"
    },
    "支付方式": {
        "zh": "支付方式",
        "en":"Payment Method"
    },
    "开始时间": {
        "zh": "开始时间",
        "en":"Time-On"
    },
    "结算时间": {
        "zh": "结算时间",
        "en":"Settlement time"
    },
    "收银员": {
        "zh": "收银员",
        "en":"Cashier"
    },
    "详情": {
        "zh": "详情",
        "en":"details"
    },
    "选择日期时间": {
        "zh": "选择日期时间",
        "en":"Select Date Time"
    },
    "日营业流水": {
        "zh": "日营业流水",
        "en":"Daily business flow"
    },
    "日订单数": {
        "zh": "日订单数",
        "en":"Number of daily orders"
    },
    "日账单": {
        "zh": "日账单",
        "en":"Daily Bill"
    },
    "月账单": {
        "zh": "月账单",
        "en":"Monthly Billing"
    },
    "月营业流水": {
        "zh": "月营业流水",
        "en":"Monthly business flow"
    },
    "订单数": {
        "zh": "订单数",
        "en":"Number of orders"
    },
    "订单管理": {
        "zh": "订单管理",
        "en":"Order Management"
    },
    "结单时间：": {
        "zh": "结单时间：",
        "en":"Closing time:"
    },
    "暂未结账": {
        "zh": "暂未结账",
        "en":"Not yet settled"
    },
    "桌台管理": {
        "zh": "桌台管理",
        "en":"Table Management"
    },
    "菜品管理": {
        "zh": "菜品管理",
        "en":"Dish Management"
    },
    "账单管理": {
        "zh": "账单管理",
        "en":"Billing Management"
    },
    "确定退出登录吗？": {
        "zh": "确定退出登录吗？",
        "en":"Are you sure to log out?"
    },
    "提示": {
        "zh": "提示",
        "en":"prompt"
    },
    "大王炭火烤肉料理": {
        "zh": "大王炭火烤肉料理",
        "en":"TOP ONE TAN HUO BBQ"
    },
    "已售罄": {
        "zh": "已售罄",
        "en":"Sold out"
    },
    "打印": {
        "zh": "打印",
        "en":"print"
    },
    "打印成功": {
        "zh": "打印成功",
        "en":"Printing successful"
    },
    "欢迎进入": {
        "zh": "欢迎进入",
        "en":"Welcome to"
    },
    "店铺": {
        "zh": "店铺",
        "en":""
    },
    "序号": {
        "zh": "序号",
        "en":"Serial Number"
    },
    "￥": {
        "zh": "￥",
        "en":"RM"
    },
    "至": {
        "zh": "至",
        "en":"To"
    },
    "暂无数据": {
        "zh": "暂无数据",
        "en":"There is currently no data available"
    },
    "会员管理": {
        "zh": "会员管理",
        "en":"Member Management"
    },
    "会员号": {
        "zh": "会员号",
        "en":"Member ID"
    },
    "手机号": {
        "zh": "手机号",
        "en":"Cell-Phone Number"
    },
    "余额(元)": {
        "zh": "余额(元)",
        "en":"Balance (RM)"
    },
    "最后充值时间": {
        "zh": "最后充值时间",
        "en":"Last Recharge Time"
    },
    "收银员": {
        "zh": "收银员",
        "en":"Cashier"
    },
    "姓名": {
        "zh": "姓名",
        "en":"Full Name"
    },
    "添加会员": {
        "zh": "添加会员",
        "en":"Add Members"
    },
    "充值": {
        "zh": "充值",
        "en":"Recharge"
    },
    "消费记录": {
        "zh": "消费记录",
        "en":"Consumption Records"
    },
    "查询": {
        "zh": "查询",
        "en":"Query"
    },
    "会员手机号": {
        "zh": "会员手机号",
        "en":"Member's Phone Number"
    },
    "会员姓名": {
        "zh": "会员姓名",
        "en":"Member Name"
    },
    "充值类型": {
        "zh": "充值类型",
        "en":"Recharge Type"
    },
    "充值金额": {
        "zh": "充值金额",
        "en":"Recharge Amount"
    },
    "充值余额": {
        "zh": "充值余额",
        "en":"Recharge Balance"
    },
    "消费明细": {
        "zh": "消费明细",
        "en":"Consumption Details"
    },
    "时间": {
        "zh": "时间",
        "en":"Time"
    },
    "金额(元)": {
        "zh": "金额(元)",
        "en":"Amount (RM)"
    },
    "消费时间": {
        "zh": "消费时间",
        "en":"Dissipate"
    },
    "备注": {
        "zh": "备注",
        "en":"Notes"
    },
    "消费类型": {
        "zh": "消费类型",
        "en":"Consumption Type"
    },
    "增加": {
        "zh": "增加",
        "en":"increase"
    },
    "减少": {
        "zh": "减少",
        "en":"reduce"
    },
    "编辑": {
        "zh": "编辑",
        "en":"Edit"
    },
    "店铺": {
        "zh": "店铺",
        "en":""
    },
}

export default language



//////////////////
// WEBPACK FOOTER
// ./static/i18n/zh.js
// module id = null
// module chunks = 